import { NgModule } from '@angular/core';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.AuthServiceProxy,
        ApiServiceProxies.TenancyDynamicServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.RegisterServiceProxy,
        ApiServiceProxies.RolServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.OrgUnitServiceProxy,
        ApiServiceProxies.UserConfigurationServiceProxy,
        ApiServiceProxies.ChangeLogServiceProxy,
        ApiServiceProxies.MailGroupServiceProxy,
        ApiServiceProxies.FileServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.HelpServiceProxy,
        ApiServiceProxies.SettingClientServiceProxy,
        ApiServiceProxies.MobileServiceProxy,
        ApiServiceProxies.WorkShiftServiceProxy,
        ApiServiceProxies.ActivityTypeServiceProxy,
        ApiServiceProxies.ProviderServiceProxy,
        ApiServiceProxies.StoreMovementTypeServiceProxy,
        ApiServiceProxies.ZoneServiceProxy,
        ApiServiceProxies.AreaServiceProxy,
        ApiServiceProxies.DamageTypeServiceProxy,
        ApiServiceProxies.ReasonSuspensionServiceProxy,
        ApiServiceProxies.LocationTypeServiceProxy,
        ApiServiceProxies.LocationServiceProxy,
        ApiServiceProxies.MarketMaxAndMinServiceProxy,
        ApiServiceProxies.PartServiceProxy,
        ApiServiceProxies.PartMexiServiceProxy,
        ApiServiceProxies.PlatformServiceProxy,
        ApiServiceProxies.RouteServiceProxy,
        ApiServiceProxies.CommodityServiceProxy,
        ApiServiceProxies.CommodityMexiServiceProxy,
        ApiServiceProxies.CommodityGroupServiceProxy,
        ApiServiceProxies.PickListServiceProxy,
        ApiServiceProxies.UploadServiceProxy,
        ApiServiceProxies.DownloadScheduleServiceProxy,
        ApiServiceProxies.ReportServiceProxy,
        ApiServiceProxies.InventoryServiceProxy,
        ApiServiceProxies.DownloadServiceProxy,
        ApiServiceProxies.ReturnableServiceProxy,
        ApiServiceProxies.SupplyCardRouteServiceProxy,
        ApiServiceProxies.LockServiceProxy,
        ApiServiceProxies.ReasonRestartServiceProxy,
        ApiServiceProxies.GrupoInventarioServiceProxy,
        ApiServiceProxies.NumeroPartesServiceProxy,
        ApiServiceProxies.TractorServiceProxy,
        ApiServiceProxies.TaktTimeServiceProxy,
        ApiServiceProxies.ModeloServiceProxy,
        ApiServiceProxies.ProgramaProduccionFramesServiceProxy,
        ApiServiceProxies.DollyClasificacionServiceProxy,
        ApiServiceProxies.DynamicSelectServiceProxy,
        ApiServiceProxies.DynamicSelectOptionsServiceProxy,
        ApiServiceProxies.TaktTimeServiceProxy,
        ApiServiceProxies.ProgramaProduccionBoteServiceProxy,
        ApiServiceProxies.AlmacenServiceProxy,
        ApiServiceProxies.CausaFaltanteServiceProxy,
        ApiServiceProxies.DollyServiceProxy,
        ApiServiceProxies.LineaProduccionServiceProxy,
        ApiServiceProxies.LineaProduccionCommodityGrupoServiceProxy,
        ApiServiceProxies.DetalladoServiceProxy,
        ApiServiceProxies.FolioServiceProxy,
        ApiServiceProxies.EtiquetasServiceProxy,
        ApiServiceProxies.EscanearMarcarFaltantesServiceProxy,
        ApiServiceProxies.ReiniciarSecuenciaGrupoServiceProxy,
        ApiServiceProxies.SequencesServiceProxy,
        ApiServiceProxies.ConsultaDollyServiceProxy,
        ApiServiceProxies.LineaTransportistaServiceProxy,
        ApiServiceProxies.ChoferServiceProxy,
        ApiServiceProxies.SecuenciaActualLineaProduccionServiceProxy,
        ApiServiceProxies.OjoBufferServiceProxy,
        ApiServiceProxies.CajaServiceProxy,
        ApiServiceProxies.NotificationPreferencesServiceProxy,
        ApiServiceProxies.UserNotificationsServiceProxy,
        ApiServiceProxies.SecuenciaFaltanteServiceProxy,
        ApiServiceProxies.ProgramasDetalleServiceProxy,
        ApiServiceProxies.CierreDollyServiceProxy,
        ApiServiceProxies.CajasEnviosServiceProxy,
        ApiServiceProxies.PlanesCargaServiceProxy,
        ApiServiceProxies.ArriboCajasServiceProxy,
        ApiServiceProxies.DescargaCajasServiceProxy,
        ApiServiceProxies.TransitoCajasServiceProxy,
        ApiServiceProxies.ComandaServiceProxy,
        ApiServiceProxies.InventarioGeneralServiceProxy,
        ApiServiceProxies.PartesRecuperacionServiceProxy,
        ApiServiceProxies.CargaInventarioServiceProxy,
        ApiServiceProxies.CargaSICServiceProxy,
        ApiServiceProxies.ConfigPickListServiceProxy,
        ApiServiceProxies.PlanTrabajoServiceProxy,
        ApiServiceProxies.ConfiguracionPDFServiceProxy,
        ApiServiceProxies.ReporteKpiServiceProxy,
        ApiServiceProxies.AdministrarPruebasServiceProxy,
        ApiServiceProxies.CausaComandaServiceProxy,
        ApiServiceProxies.SesionesDispositivosMovilesServiceProxy,
        ApiServiceProxies.TiempoEfectivoServiceProxy,
        ApiServiceProxies.ValidacionConfiguracionServiceProxy
    ]
})
export class ServiceProxyModule { }
